module.exports = __webpack_public_path__ + "img/multiple-icon-1.6bea6500.png";